@if((isFullScreenloader$ | async) || isRelativeLoader) {
<div [class]="mainDivClass">
    <div [class]="containerDivClass">
        <mat-progress-spinner [diameter]="diameter" mode="indeterminate"></mat-progress-spinner>
    </div>
</div>
}